import { useContext } from 'react'
import InternationalizationContext from 'contexts/InternationalizationContext'
import { InternationalizationState } from 'services/shared/Internationalization'

function useInternationalization(): InternationalizationState {
  const locationState = useContext(InternationalizationContext);

  return locationState
}

export default useInternationalization